import { createAction } from '@ngrx/store';

export const openT4FDiscountForm = createAction('[PartnerDeals] (T4F) Open 10% Discount Form');
